import type { LogRole } from "../../core/types.js";
import { getRoleColor } from "./rolePermissionsModel.js";

export function RoleChip(props: { role: LogRole; selected?: boolean; removable?: boolean; onClick?: () => void }) {
    return (
        <button class={{ "bulk-role-chip": true, selected: props.selected, removable: props.removable }} onClick={props.onClick}>
            <span class="bulk-role-chip-dot" style={{ background: getRoleColor(props.role) }} />
            {props.role.unicodeEmoji && <small>{props.role.unicodeEmoji}</small>}
            <strong>{props.role.name}</strong>
            {props.selected && <i class="material-symbols-outlined">{props.removable ? "close" : "check"}</i>}
        </button>
    );
}
